(() => {
  const rootPath = () => window.Shopify?.routes?.root || '/';

  function money(cents) {
    return `R$ ${(Number(cents) / 100).toFixed(2).replace('.', ',')}`;
  }

  function cepDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function maskCep(value) {
    const digits = cepDigits(value);
    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
  }

  function initCart(root) {
    if (root.dataset.cdgCartReady === 'true') return;
    root.dataset.cdgCartReady = 'true';

    const form = root.querySelector('[data-cdg-cart-form]');

    root.querySelectorAll('.cdg-cart__item').forEach((item) => {
      const input = item.querySelector('[data-cdg-qty]');
      item.querySelector('[data-cdg-qty-minus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = String(Math.max(0, Number(input.value || 1) - 1));
        const updateBtn = form?.querySelector('[name="update"]');
        if (form?.requestSubmit) form.requestSubmit(updateBtn);
        else form?.submit();
      });
      item.querySelector('[data-cdg-qty-plus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = String(Math.max(1, Number(input.value || 1) + 1));
        const updateBtn = form?.querySelector('[name="update"]');
        if (form?.requestSubmit) form.requestSubmit(updateBtn);
        else form?.submit();
      });
    });

    const coupon = root.querySelector('[data-cdg-coupon]');
    const couponInput = root.querySelector('[data-cdg-coupon-input]');
    coupon?.addEventListener('submit', (event) => {
      event.preventDefault();
      const code = String(couponInput?.value || '').trim();
      if (!code) return;
      window.location.href = `${rootPath()}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(rootPath().replace(/\/$/, '') + '/cart')}`;
    });

    const cepInput = root.querySelector('[data-cdg-cep]');
    const cepStatus = root.querySelector('[data-cdg-cep-status]');
    const cepRates = root.querySelector('[data-cdg-cep-rates]');

    cepInput?.addEventListener('input', () => {
      cepInput.value = maskCep(cepInput.value);
    });

    function setCepStatus(message, isError) {
      if (!cepStatus) return;
      cepStatus.hidden = !message;
      cepStatus.textContent = message || '';
      cepStatus.classList.toggle('is-error', Boolean(isError));
    }

    function deliveryText(rate) {
      const days = rate.delivery_days;
      if (Array.isArray(days) && days.length) {
        const min = days[0];
        const max = days[days.length - 1];
        return min === max ? `${min} dias úteis` : `${min} a ${max} dias úteis`;
      }
      return rate.delivery_range ? String(rate.delivery_range) : '';
    }

    function applyFreight(rates) {
      const totals = root.querySelector('[data-cdg-totals]');
      if (!totals || !rates.length) return;
      const chosen = rates.reduce((best, rate) => (Number(rate.price) < Number(best.price) ? rate : best), rates[0]);
      const freightCents = Math.round(Number(chosen.price) * 100);
      const subtotal = Number(totals.dataset.subtotal || 0);
      const pixBase = Number(totals.dataset.pix || 0);
      const freightRow = totals.querySelector('[data-cdg-freight]');
      const freightValue = totals.querySelector('[data-cdg-freight-value]');
      const totalValue = totals.querySelector('[data-cdg-total-value]');
      const pixValue = totals.querySelector('[data-cdg-pix-value]');
      if (freightRow) freightRow.hidden = false;
      if (freightValue) freightValue.textContent = freightCents === 0 ? 'Grátis' : money(freightCents);
      if (totalValue) totalValue.textContent = money(subtotal + freightCents);
      if (pixValue) pixValue.textContent = money(pixBase + freightCents);
      const note = root.querySelector('[data-cdg-shipping-note]');
      if (note) note.hidden = true;
      const taxNote = root.querySelector('[data-cdg-tax-note]');
      if (taxNote) taxNote.textContent = 'Frete estimado para este CEP. A confirmação acontece no checkout.';
    }

    async function quoteShipping() {
      const zip = cepDigits(cepInput?.value);
      if (zip.length !== 8) {
        setCepStatus('Digite um CEP válido com 8 dígitos.', true);
        return;
      }

      const submit = root.querySelector('[data-cdg-cep-submit]');
      setCepStatus('Consultando CEP…', false);
      if (submit) submit.disabled = true;
      if (cepRates) {
        cepRates.hidden = true;
        cepRates.replaceChildren();
      }

      let place = '';
      let uf = '';
      try {
        const via = await fetch(`https://viacep.com.br/ws/${zip}/json/`).then((response) => response.json());
        if (via.erro) {
          setCepStatus('CEP não encontrado.', true);
          if (submit) submit.disabled = false;
          return;
        }
        place = [via.localidade, via.uf].filter(Boolean).join('/');
        uf = via.uf || '';
      } catch (error) {
        console.warn('CDG cart: ViaCEP indisponível', error);
      }

      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': 'Brazil'
      });
      if (uf) params.set('shipping_address[province]', uf);

      try {
        const response = await fetch(`${rootPath()}cart/shipping_rates.json?${params}`);
        if (response.ok) {
          const data = await response.json();
          const rates = data.shipping_rates || [];
          if (rates.length && cepRates) {
            cepRates.hidden = false;
            rates.forEach((rate) => {
              const item = document.createElement('li');
              item.className = 'cdg-pdp__shipping-rate';
              const copy = document.createElement('div');
              const name = document.createElement('strong');
              name.textContent = rate.presentment_name || rate.name || 'Frete';
              copy.append(name);
              const days = deliveryText(rate);
              if (days) {
                const prazo = document.createElement('span');
                prazo.textContent = days;
                copy.append(prazo);
              }
              const price = document.createElement('b');
              price.textContent = Number(rate.price) === 0 ? 'Grátis' : money(Math.round(Number(rate.price) * 100));
              item.append(copy, price);
              cepRates.append(item);
            });
            applyFreight(rates);
            setCepStatus(place ? `Entrega para ${place}` : '', false);
            return;
          }
        }
      } catch (error) {
        console.warn('CDG cart: shipping_rates indisponível', error);
      } finally {
        if (submit) submit.disabled = false;
      }

      setCepStatus(`${place ? place + ': ' : ''}frete e prazo confirmados no checkout.`, false);
    }

    root.querySelector('[data-cdg-cep-submit]')?.addEventListener('click', quoteShipping);
    cepInput?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        quoteShipping();
      }
    });

    root.querySelector('[data-cdg-begin-checkout]')?.addEventListener('click', () => {
      let payload = { currency: 'BRL', value: 0, items: [] };
      try {
        const jsonEl = root.querySelector('[data-cdg-cart-json]');
        if (jsonEl) payload = JSON.parse(jsonEl.textContent);
      } catch (error) {
        console.warn('CDG track begin_checkout', error);
      }
      window.cdgTrack?.('begin_checkout', payload);
    });
  }

  document.querySelectorAll('[data-cdg-cart]').forEach(initCart);
})();
